import React from 'react';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  VALUE_INPUT_TYPE_DATE,
  VALUE_INPUT_TYPE_BOOLEAN,
  VALUE_INPUT_TYPE_TEXT_AND_SEARCH,
} from 'pages/RolesAndPermissions/consts';
import * as Types from 'pages/RolesAndPermissions/typings';

import TextField from '@material-ui/core/TextField';
import FreeformAndSearchInput from './FreeformAndSearchInput';
import SelectInput from './SelectInput';

interface Props {
  inputType: Types.FilterValueInputType;
  input?: string;
  fieldObjectKey?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelect: (value: string) => void;
}

function FilterValueInput({ input, inputType, fieldObjectKey, onChange, onSelect }: Props) {
  const classes = useStyles();

  if (inputType === VALUE_INPUT_TYPE_BOOLEAN) {
    return <SelectInput options={['true', 'false']} onSelect={onSelect} />;
  }

  if (inputType === VALUE_INPUT_TYPE_TEXT_AND_SEARCH) {
    return (
      <>
        <FreeformAndSearchInput
          input={input || ''}
          onChange={onChange}
          fieldObjectKey={fieldObjectKey || ''}
          onSelect={onSelect}
        />
      </>
    );
  }

  if (inputType === VALUE_INPUT_TYPE_DATE) {
    return (
      <>
        <input
          type="date"
          value={input}
          onChange={e => onSelect(e.target.value)}
          className={classNames(classes.root, classes.datePicker)}
        />
      </>
    );
  }

  return (
    <TextField
      className={classNames(classes.root, classes.textField)}
      placeholder={'Add value'}
      onChange={onChange}
      fullWidth
      value={input}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          onSelect(input || '');
        }
      }}
    />
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  datePicker: {
    width: '100%',
  },
  textField: {
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    '& input': {
      paddingLeft: theme.spacing(),
      paddingRight: theme.spacing(),
    },
  },
}));

export default FilterValueInput;
